var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "@emotion/styled";
export var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\toverflow: hidden;\n\tflex-shrink: 0;\n"], ["\n\toverflow: hidden;\n\tflex-shrink: 0;\n"])));
var templateObject_1;
